import React, { Component } from "react";
import { checkAuthentification } from "./actions/authActions";
import { BrowserRouter } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import history from "./components/history";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Pages from "./components/Pages";
import ReactGA from "react-ga";
// import RouteChangeTracker from "./components/RouteChangeTracker";
// import GoogleAnalytics from "./GoogleAnalytics";

class AppStore extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authentificated: null,
      // location: "",
    };
  }
  componentDidMount() {
    // store.dispatch(loadUser());
    this.props.checkAuthentification();
    // ReactGA.initialize("G-218QT8EDCS");
  }

  componentDidUpdate() {
    this.props.checkAuthentification();
    if (this.state.authentificated !== this.props.authentificated) {
      this.setState({ authentificated: this.props.authentificated });

      //!!!!!! for development purpose no ReactGA.
      // ReactGA.set({ anonymizeIp: true });
      //report page view
      // let pathN = window.
      // ReactGA.pageview(window.)
    }

    // history.listen((location, action) => {
    //   if (location.pathname !== this.state.location) {
    //     ReactGA.set({ page: location.pathname });
    //     ReactGA.pageview(location.pathname);
    //     this.setState({ location: location.pathname });
    //   }
    // });
  }

  static propTypes = {
    checkAuthentification: PropTypes.func.isRequired,
    isAuthenticated: PropTypes.bool,
  };

  render() {
    return this.props.isAuthenticated !== null ? (
      <>
        {/* <GoogleAnalytics /> */}
        <BrowserRouter history={history}>
          {/* <GoogleAnalytics trackingID={"G-218QT8EDCS"} /> */}
          {/* <RouteChangeTracker /> */}
          {/* <Route component={Pages} /> */}
          <Pages
            history={history}
            isAuthenticated={this.props.isAuthenticated}
          />
        </BrowserRouter>
      </>
    ) : null;
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  // this is props so add prop type
});

export default connect(mapStateToProps, {
  checkAuthentification,
})(AppStore);

// export default App;
